var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user-button-new",on:{"click":_vm.newUser}},[_vm._v("\n  新しいユーザーの作成\n")])}
var staticRenderFns = []

export { render, staticRenderFns }